import { type PropsWithChildren, type ReactNode, useState } from "react";
import ChevronIcon from "@/assets/icons/chevron.svg?react";
import { cn } from "@/lib/utils";

type ExpandableProps = {
  titleClassName?: string;
  className?: string;
  title: ReactNode;
  controlled?: boolean;
  isDisabled?: boolean;
  isExpanded?: boolean;
  setIsExpanded?: () => void;
};
export default function Expandable({
  children,
  title,
  isExpanded = false,
  setIsExpanded,
  isDisabled = false,
  controlled,
  titleClassName,
  className,
}: PropsWithChildren<ExpandableProps>) {
  const [isOpen, setIsOpen] = useState(isExpanded);

  const expandHandler = () => {
    if (isDisabled) return;
    if (controlled && setIsExpanded) {
      setIsExpanded();
    } else {
      setIsOpen((prevState) => !prevState);
    }
  };

  const shouldBeOpen = isExpanded || isOpen;
  return (
    <div className={cn("rounded", className)}>
      <div className={cn("flex items-center gap-2", isOpen && "mb-7", isDisabled && "text-gray-600", titleClassName)}>
        {title}
        <button className="ml-auto rounded-lg border border-solid border-gray-200 p-[14px]" onClick={expandHandler}>
          <ChevronIcon
            // @ts-expect-error
            data="expand-btn"
            className={cn(isOpen ? "rotate-90" : "-rotate-90", isDisabled ? "fill-[#A5A5A5]" : "cursor-pointer")}
          />
        </button>
      </div>
      {shouldBeOpen && children}
    </div>
  );
}
